import React from "react";
const PlayIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 4.00142V19.0034C5 19.7884 5.864 20.2674 6.53 19.8514L18.537 12.3504C19.164 11.9584 19.164 11.0464 18.537 10.6544L6.53 3.15342C5.864 2.73742 5 3.21642 5 4.00142Z",
      fill: "currentColor"
    }
  )
);
var PlayIcon_default = PlayIcon;
export {
  PlayIcon_default as default
};
//# sourceMappingURL=PlayIcon.js.map
